<template>
  <La0 :ratio="'1179px 632px'" :style="{height: '100%', marginLeft:'30px', width: 'calc(100vw - 109px)'}">
    <div slot="left" class="leftChart">
      <div>
        <div>熱門區域統計</div>
        <ChartPie :result="areaResult"/>
      </div>
      <div>
        <div>全區前10熱門景點 <Select :style="{marginLeft: '20px'}" width='200px' :defaultValue="tabTypeChart" @input="tabTypeChart=$event"><option v-for="(opt, o) in options" :key="`chart-${o}`" :value="opt">{{opt}}</option></Select></div>
        <ChartPie :result="top10"/>
      </div>
      <div>
        <div>單區域統計排名 <Select :style="{marginLeft: '20px'}" width='200px' :defaultValue="area" @input="area=$event"><option v-for="(opt, o) in areas" :key="`area-${o}`" :value="opt">{{opt.name}}</option></Select></div>
        <ChartPie :result="singleArea"/>
      </div>
    </div>
    <div :style="{paddingRight: '10px'}">
      <div class="rightHead">數據統計 <Select :style="{marginLeft: '20px'}" width='250px' :defaultValue="tabType" @input="tabType=$event"><option v-for="(opt, o) in options" :key="o" :value="opt">{{opt}}</option></Select></div>
      <Table :rows="rows2">
        <template slot="slot_head">
          <th :style="{textAlign: 'start'}">地點名稱</th>
          <th :style="{textAlign: 'end'}">次數</th>
        </template>
        <tr slot-scope="item" :style="{border:'none', height: '64px'}">
          <td :style="{textAlign: 'start'}">{{item.item.name}}</td>
          <td :style="{textAlign: 'end'}" v-if="tabType==='點擊次數'">{{item.item.num}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='圖文解說'">{{item.item.info}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='(語音1)'">{{item.item.audio[0] ? item.item.audio[0].num : '-'}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='(語音2)'">{{item.item.audio[1] ? item.item.audio[1].num : '-'}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='(影音1)'">{{item.item.video[0] ? item.item.video[0].num : '-'}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='(影音2)'">{{item.item.video[1] ? item.item.video[1].num : '-'}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='(影音3)'">{{item.item.video[2] ? item.item.video[2].num : '-'}}</td>
          <td :style="{textAlign: 'end'}" v-else-if="tabType==='(影音4)'">{{item.item.video[3] ? item.item.video[3].num : '-'}}</td>
        </tr>
      </Table>
    </div>
  </La0>
</template>

<script>
import Table from '../../components/tables/t2.vue'
import Select from '../../components/select.vue'
import La0 from '../../components/layout/La0.vue'
import ChartPie from './chart2.vue'
export default {
  props: ['rows', 'areas'],
  components: {
    ChartPie,
    La0,
    Select,
    Table
  },
  data () {
    return {
      tabTypeChart: '點擊次數',
      tabType: '點擊次數',
      options: '點擊次數_(語音1)_(語音2)_圖文解說_(影音1)_(影音2)_(影音3)_(影音4)'.split('_'),
      area: null
    }
  },
  computed: {
    areaResult () {
      return this.areas.map(e => {
        return {
          name: e.name,
          count: this.rows.filter(r => r.area._id === e._id).map(e => e.num).reduce((a, b) => a + b, 0)
        }
      })
    },
    top10 () {
      const rows = JSON.parse(JSON.stringify(this.rows))
      switch (this.tabTypeChart) {
        case '(語音1)':
          return rows.filter(a => a.audio[0]).sort((a, b) => a.audio[0].num > b.audio[0].num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        case '(語音2)':
          return rows.filter(a => a.audio[1]).sort((a, b) => a.audio[1].num > b.audio[1].num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        case '圖文解說':
          return rows.sort((a, b) => a.info > b.info ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        case '(影音1)':
          return rows.filter(a => a.video[0]).sort((a, b) => a.video[0].num > b.video[0].num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        case '(影音2)':
          return rows.filter(a => a.video[1]).sort((a, b) => a.video[1].num > b.video[1].num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        case '(影音3)':
          return rows.filter(a => a.video[2]).sort((a, b) => a.video[2].num > b.video[2].num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        case '(影音4)':
          return rows.filter(a => a.video[3]).sort((a, b) => a.video[3].num > b.video[3].num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
        default:
          return rows.sort((a, b) => a.num > b.num ? -1 : 1).slice(0, 10).map(e => {
            return {
              name: e.name,
              count: e.num
            }
          })
      }
    },
    rows2 () {
      const rows = JSON.parse(JSON.stringify(this.rows))
      switch (this.tabType) {
        case '(語音1)':
          return rows.filter(a => a.audio[0]).sort((a, b) => a.audio[0].num > b.audio[0].num ? -1 : 1)
        case '(語音2)':
          return rows.filter(a => a.audio[1]).sort((a, b) => a.audio[1].num > b.audio[1].num ? -1 : 1)
        case '圖文解說':
          return rows.sort((a, b) => a.info > b.info ? -1 : 1)
        case '(影音1)':
          return rows.filter(a => a.video[0]).sort((a, b) => a.video[0].num > b.video[0].num ? -1 : 1)
        case '(影音2)':
          return rows.filter(a => a.video[1]).sort((a, b) => a.video[1].num > b.video[1].num ? -1 : 1)
        case '(影音3)':
          return rows.filter(a => a.video[2]).sort((a, b) => a.video[2].num > b.video[2].num ? -1 : 1)
        case '(影音4)':
          return rows.filter(a => a.video[3]).sort((a, b) => a.video[3].num > b.video[3].num ? -1 : 1)
        default:
          return rows.sort((a, b) => a.num > b.num ? -1 : 1)
      }
    },
    singleArea () {
      return this.area ? this.rows.filter(e => e.area._id === this.area._id).map(e => {
        return {
          name: e.name,
          count: e.num
        }
      }) : []
    }
  },
  created () {
    this.area = this.areas[0]
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.leftChart {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  height: calc(100vh - 90px);
  padding-block: 28px;
  &>div{
    height: 50%;
    &>div:nth-child(1) {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0.1em;
      color:var(--color-checked);
      text-align: start;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 40px;
    }
  }
}
.rightHead {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.1em;
  color:var(--color-checked);
  text-align: start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 95px;
  padding-inline: 40px;
}
</style>
